import Cookies from 'js-cookie';

const apiEndpoint = process.env.API_ENDPOINT;
//Headers
const defaultHeaders = {
	'Content-Type': 'application/json;charset=UTF-8',
	'Accept': 'application/json',
};

export default class API {

	static headers = defaultHeaders;

    static fetch(resourceURL, method, data, hasFiles) {

		const cookies = Cookies.getJSON('auth.response.user');
		let token = cookies ? cookies.token : undefined;

		if (token !== undefined) {
			this.headers = Object.assign(defaultHeaders, {
				Authorization: `${token}`
			});
		} else {
			token = '';
			this.headers = Object.assign(defaultHeaders, {
				Authorization: '',
			});
		}

        const isFormData = (method === 'POST' && hasFiles);
		let headers = Object.assign({}, this.headers);
		if (isFormData) {
			delete headers['Content-Type'];
		}
		let config = {
			method: method,
			headers: headers,
			mode: 'cors'
		};
		if (data) {
			if (isFormData) {
				if (typeof (data) !== 'object') {
					throw new Error('Para efetuar post de arquivos, é obrigatório o recebimento de "data" como objeto');
				}
				config.body = new FormData();
				let object = {};

				for (let index in data) {
					if (!data.hasOwnProperty(index)) {
						continue;
					}
					const value = data[index];
					if (value instanceof File) {
						config.body.append(index, value);
						continue;
					}
					if (value instanceof Array) {
						if (value.length === 0) {
							object[index] = value;
							continue;
						}
						const isFileList = (value[0] instanceof File);
						for (let indexFile = 0; indexFile < value.length; indexFile++) {
							const isFile = (value[indexFile] instanceof File);
							if ((isFile && !isFileList) || (!isFile && isFileList)) {
								throw new Error('A lista não pode possuir arquivos e outros valores junto.');
							}
						}
						if (isFileList) {
							for (let indexFile = 0; indexFile < value.length; indexFile++) {
								config.body.append(`${index}[${indexFile}]`, value[indexFile])
							}
						} else {
							object[index] = value;
						}
						continue;
					}

					object[index] = value;
				}
				config.body.append('json', new Blob(
					[JSON.stringify(object)],
					{ type: "application/json;charset=UTF-8" }
				));
			} else {
				config.body = JSON.stringify(data);
			}
		}
		return fetch(apiEndpoint + resourceURL, config);
	}

    static get(resourceURL) {
        return this.fetch(resourceURL, 'GET');
    }

    static post(resourceURL, data) {
        return this.fetch(resourceURL, 'POST', data);
	}

	static postWithFiles(resourceURL, data) {
		return this.fetch(resourceURL, 'POST', data, true);
	}

    static put(resourceURL, data) {
        return this.fetch(resourceURL, 'PUT', data);
    }

    static delete(resourceURL) {
        return this.fetch(resourceURL, 'DELETE');
    }

    static download(resourceURL) {
        return window.open(apiEndpoint+resourceURL,'_BLANK');
    }

}



// WEBPACK FOOTER //
// ./src/services/api/API.js